var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-filter',{staticClass:"customer-details-filter",attrs:{"item-acceptable":_vm.itemAcceptable,"prompt-text":_vm.promptText || _vm.t('prompt'),"value":_vm.value},on:{"input":function($event){return _vm.handleSubfilterInput($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }